import appStore from './en-US/app-store';
import applicationCatalog from './en-US/application-catalog';
import applicationCenter from './en-US/application-center';
import applicationFeedback from './en-US/application-feedback';
import businessAppMarket from './en-US/business-app-market';
import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import markets from './en-US/markets';
import menu from './en-US/menu';
import myApps from './en-US/my-apps';
import navigation from './en-US/navigation';
import pages from './en-US/pages';
import platformSettings from './en-US/platform-settings';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import system from './en-US/system';
import workbench from './en-US/workbench';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.footer.copyright': '2026 Coral Wisdom (Beijing) Technology Co., Ltd.',
  'app.preview.down.block': 'Download this page to your local project',
  'app.workbench.link.fetch-blocks': 'Get all block',
  'app.workbench.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...system,
  ...navigation,
  ...workbench,
  ...applicationCatalog,
  ...applicationCenter,
  ...applicationFeedback,
  ...businessAppMarket,
  ...markets,
  ...myApps,
  ...appStore,
  ...platformSettings,
};
